<template>
  <header class="header-global">
    <div class="container top-header d-none d-lg-block">
      <div class="row">
        <div class="col-auto mr-auto">
          <router-link slot="brand" class="navbar-brand mr-5" to="/">
            <img src="img/brand/arctec_logo_light.png" alt="ARCTEC Welding logo" />
          </router-link>
        </div>
        <div class="col-auto d-flex align-items-center">
          <p class="text-right pr-2 m-0">
            Unit 1, Damastown Way
            <br />Damastown Industrial Park
            <br />Mulhuddart, Dublin 15
            <br />+353 (0)18261377
            <br />sales@arctec.ie
          </p>
        </div>
      </div>
    </div>
    <base-nav class="navbar-main" type="primary" effect="dark" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5 d-lg-none" to="/">
        <img src="img/brand/arctec_logo_light.png" alt="ARCTEC Welding logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <a href="/">
            <img src="img/brand/arctec_logo_light.png" alt="ARCTEC Welding logo" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-dark navbar-nav-hover align-items-lg-center">
        <li class="nav-item">
          <router-link to="/" class="nav-link">Home</router-link>
        </li>
        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <span slot="title" class="nav-link d-flex" data-toggle="dropdown" role="button">
            <span style="color: inherit;">Products</span>
            <span class="d-block d-lg-none" style="margin-left: auto">
              <i class="fa fa-plus"></i>
            </span>
          </span>
          <div class="dropdown-menu-inner pt-1">
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-12 col-sm-6 col-md-4 mt-3"
                  v-for="range in ranges"
                  :key="range.name"
                >
                  <router-link
                    tag="a"
                    class="navbar-dropdown-link"
                    :to="`/ranges/${range.id}`"
                    @click="$root.$emit('bv::toggle::collapse', 'dropdown')"
                  >{{range.name}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </base-dropdown>
        <li class="nav-item">
          <router-link to="/catalogues" class="nav-link">Catalogues</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/about-us" class="nav-link">About Us</router-link>
        </li>
        <li class="nav-item mt-3 d-lg-none">
          <a href="#/contact-us" rel="noopener" class="btn btn-warning btn-icon">
            <span class="btn-inner--icon">
              <i class="fa fa-phone mr-2"></i>
            </span>
            <span class="nav-link-inner--text">Contact Us</span>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item d-none d-lg-block ml-lg-4">
          <a href="#/contact-us" rel="noopener" class="btn btn-warning btn-icon">
            <span class="btn-inner--icon">
              <i class="fa fa-phone mr-2"></i>
            </span>
            <span class="nav-link-inner--text">Contact Us</span>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  methods: {
    ...mapActions(["fetchRanges"]),
    closeNavBar() {
      var isExpanded = $(".navbar-toggle").attr("aria-expanded") === true;
      if (isExpanded) {
        $(".navbar-toggle").click();
      }
      // this.next();
    },
    isMobile() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  computed: mapGetters(["ranges"])
};
</script>
<style lang="scss">
.dropdown-menu {
  padding-top: 0;
}
.dropdown-menu-inner {
  width: 100%;

  @media all and (min-width: 1024px) and (max-width: 1365px) {
    width: 90vw;
  }

  @media all and (min-width: 1366px) and (max-width: 1599px) {
    width: 60vw;
  }

  @media all and (min-width: 1600px) {
    width: 40vw;
  }

  .navbar-dropdown-link {
    font-size: 1em;
    color: #172b4d;
    padding-left: 0;
  }
}
.top-header {
  padding-top: 1em;
  padding-bottom: 1em;

  .navbar-brand {
    padding: 1em;

    img {
      height: 125px;
    }
  }
}
.navbar {
  border-bottom-width: 0px !important;
}
</style>
